
import useMobile from '../../hooks/useMobile';
import Sector from './Sector/Sector';

function Sectors(props) {
  const isMobile = useMobile()
  return (
    <div style={isMobile ? { marginBottom: '110px'} : {}}>
        {props.data && ( props.data.map((item, index)=>{
          return( 
          <Sector 
            key={index}
            item={item}
            selectedServices={props.selectedServices}
            onServiceSelect={props.onServiceSelect} onServiceDeSelect={props.onServiceDeSelect}
            showSearchBox={index===0}
            onSearch={props.onSearch}
            currentStep={props.currentStep}
          />
          ) 
        }))}
    </div>

  );
}

export default Sectors;
